import { render, staticRenderFns } from "./Theme4Gallery.vue?vue&type=template&id=7b7f1a1b&scoped=true&"
import script from "./Theme4Gallery.vue?vue&type=script&lang=js&"
export * from "./Theme4Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Theme4Gallery.vue?vue&type=style&index=0&id=7b7f1a1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7f1a1b",
  null
  
)

export default component.exports